import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Tag, HTMLTable, InputGroup, Button, Intent, Card, Elevation } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Players extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      raceFilter: 'ALL',
      statusFilter: 'ALL',
      players: [
        { name: 'Nozich', level: 110, guild: 'SROFilter_Guild', race: 'CH', build: 'Bower / Fire', location: 'Taklamakan', gold: '2.45 Bil Gold', silk: '12,800', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'Merlin', level: 110, guild: 'Asylum', race: 'EU', build: 'Wizard / Cleric', location: 'Jangan Tiger Mountain', gold: '1.82 Bil Gold', silk: '1,450', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'edjka1985', level: 110, guild: 'TwitchArmy', race: 'CH', build: 'Blader / Cold', location: 'Tarim Basin', gold: '950 Mil Gold', silk: '5,100', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'FR_Henry', level: 108, guild: 'Legion', race: 'CH', build: 'Glavier / Lightning', location: 'Constantinople Town', gold: '320 Mil Gold', silk: '320', lastSeen: '14m ago', status: 'OFFLINE' },
        { name: 'Asviix', level: 110, guild: 'Asylum', race: 'EU', build: 'Warrior / Bard', location: 'Karakoram', gold: '3.10 Bil Gold', silk: '890', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'GoldCeo', level: 105, guild: 'GoldVendors', race: 'CH', build: 'Spear / Fire', location: 'Jangan Market', gold: '14.80 Bil Gold', silk: '50', lastSeen: '1h 20m ago', status: 'OFFLINE' },
        { name: 'HandOfGod', level: 110, guild: 'GM_Staff', race: 'EU', build: 'Rogue / Cleric', location: 'GM Control Room', gold: '99.99 Bil Gold', silk: '999,999', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'Sharpknife', level: 110, guild: 'GM_Staff', race: 'EU', build: 'Rogue / Cleric', location: 'Donwhang Cave B3', gold: '1.15 Bil Gold', silk: '4,200', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'Milaa', level: 109, guild: 'Asylum', race: 'EU', build: 'Cleric / Bard', location: 'Constantinople', gold: '640 Mil Gold', silk: '1,200', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'QuieTScr3aM', level: 110, guild: 'Legion', race: 'CH', build: 'Spear / Fire', location: 'Hotan Fortress', gold: '2.05 Bil Gold', silk: '800', lastSeen: '3h 10m ago', status: 'OFFLINE' },
        { name: '_AntiFire_', level: 110, guild: 'SROFilter_Guild', race: 'EU', build: 'Wizard / Bard', location: 'Alexandria North', gold: '1.40 Bil Gold', silk: '3,100', lastSeen: 'Online Now', status: 'ONLINE' },
        { name: 'MasterForce', level: 110, guild: 'Legion', race: 'CH', build: 'Glavier / Fire', location: 'Samarkand Fields', gold: '880 Mil Gold', silk: '650', lastSeen: 'Online Now', status: 'ONLINE' },
      ]
    };
  }

  render() {
    const filtered = this.state.players.filter((p) => {
      const matchSearch = p.name.toLowerCase().includes(this.state.search.toLowerCase()) ||
        p.guild.toLowerCase().includes(this.state.search.toLowerCase());
      const matchRace = this.state.raceFilter === 'ALL' || p.race === this.state.raceFilter;
      const matchStatus = this.state.statusFilter === 'ALL' || p.status === this.state.statusFilter;
      return matchSearch && matchRace && matchStatus;
    });

    return (
      <SideMenuWrapper>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="display-4 font-italic mb-1" style={{ fontSize: '1.5rem', color: '#182026' }}>
              Players Character Database
            </h3>
            <p className="text-muted m-0" style={{ fontSize: '0.85rem' }}>
              Live query of 10,450 registered Silkroad Online characters connected to SROFilter.
            </p>
          </div>
        </div>

        {/* Telemetry Cards */}
        <div className="row mb-4">
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Total Registered</span>
              <h4 className="m-0" style={{ fontWeight: 800, color: '#182026' }}>10,450</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Online Players</span>
              <h4 className="m-0 text-success" style={{ fontWeight: 800 }}>3,142</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Offline Players</span>
              <h4 className="m-0" style={{ fontWeight: 800, color: '#5c7080' }}>7,308</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Race Ratio</span>
              <h4 className="m-0 text-info" style={{ fontWeight: 800 }}>48% CH / 52% EU</h4>
            </Card>
          </div>
        </div>

        {/* Search & Filter Bar */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
          <div className="d-flex gap-2">
            <Button
              active={this.state.raceFilter === 'ALL'}
              onClick={() => this.setState({ raceFilter: 'ALL' })}
              minimal
              small
              intent={Intent.PRIMARY}
            >
              All Races
            </Button>
            <Button
              active={this.state.raceFilter === 'CH'}
              onClick={() => this.setState({ raceFilter: 'CH' })}
              minimal
              small
              intent={Intent.WARNING}
            >
              Chinese (CH)
            </Button>
            <Button
              active={this.state.raceFilter === 'EU'}
              onClick={() => this.setState({ raceFilter: 'EU' })}
              minimal
              small
              intent={Intent.SUCCESS}
            >
              European (EU)
            </Button>
          </div>

          <div style={{ width: '240px' }}>
            <InputGroup
              leftIcon="search"
              placeholder="Search Character or Guild..."
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              small
            />
          </div>
        </div>

        {/* Table */}
        <HTMLTable bordered condensed striped interactive style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Character Name</th>
              <th style={{ color: '#182026' }}>Level</th>
              <th style={{ color: '#182026' }}>Guild</th>
              <th style={{ color: '#182026' }}>Race & Build</th>
              <th style={{ color: '#182026' }}>Map Location</th>
              <th style={{ color: '#182026' }}>Total Gold (Inv+Bank)</th>
              <th style={{ color: '#182026' }}>Silk</th>
              <th style={{ color: '#182026' }}>Last Seen</th>
              <th style={{ color: '#182026' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p, idx) => (
              <tr key={idx}>
                <td className="font-weight-bold">
                  <NavLink to={`/Players/${p.name}`} style={{ color: '#106ba3' }}>
                    {p.name}
                  </NavLink>
                </td>
                <td className="font-weight-bold text-warning">Lv. {p.level}</td>
                <td style={{ color: '#182026' }}>{p.guild}</td>
                <td style={{ color: '#182026' }}>
                  <Tag intent={p.race === 'EU' ? Intent.SUCCESS : Intent.WARNING} minimal className="mr-1">
                    {p.race}
                  </Tag>
                  <span>{p.build}</span>
                </td>
                <td style={{ color: '#5c7080' }}>{p.location}</td>
                <td className="font-mono text-warning font-weight-bold">{p.gold}</td>
                <td className="font-mono style={{ color: '#106ba3' }} font-weight-bold">{p.silk}</td>
                <td style={{ color: '#5c7080' }}>{p.lastSeen}</td>
                <td>
                  <Tag intent={p.status === 'ONLINE' ? Intent.SUCCESS : Intent.NONE} round>
                    {p.status}
                  </Tag>
                </td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>

        {/* Pagination Bar */}
        <div className="d-flex justify-content-between align-items-center mt-3" style={{ fontSize: '0.75rem', color: '#5c7080' }}>
          <span>Showing 1 - 12 of 10,450 players</span>
          <div>
            <Button icon="chevron-left" minimal small disabled />
            <span className="mx-2 font-weight-bold">Page 1 of 871</span>
            <Button icon="chevron-right" minimal small />
          </div>
        </div>
      </SideMenuWrapper>
    );
  }
}
